import authRequest from "@/api/http/authRequest";

export default {
  search(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/notice-modals`, params, cb, errCb)
  },

  delete(id: number, cb: (response) => void, errCb: (response) => void) {
    authRequest.delete(`/admin/notice-modal/${id}`, cb, errCb)
  },

  createModal(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.post(`/admin/notice-modal`,params, cb, errCb)
  },

  updateModal(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.put(`/admin/notice-modal/${params.id}`,params, cb, errCb)
  },
}
